import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql, Link } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/navigation-bar/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Summary`}</h2>
    <p>{`Navigation bars for iOS are implemented using the built-in UIKit component `}<inlineCode parentName="p">{`UINavigationBar`}</inlineCode>{`, however they should be configured using the Thumbprint decorator method `}<inlineCode parentName="p">{`NavigationBar.configure(_:appearance:content:)`}</inlineCode>{` to apply one of the standard Thumbprint navigation bar styles.`}</p>
    <h3>{`Appearance`}</h3>
    <p>{`There are three standard navigation bar appearances. In addition, custom themes can be defined by calling the `}<inlineCode parentName="p">{`NavigationBar.Appearance`}</inlineCode>{` constructor directly.`}</p>
    <h4>{`Default`}</h4>
    <p><img parentName="p" {...{
        "src": "/img/ios-navigation-bar-default.png",
        "alt": "Default navigation bar"
      }}></img></p>
    <h4>{`Shadowless`}</h4>
    <p><img parentName="p" {...{
        "src": "/img/ios-navigation-bar-shadowless.png",
        "alt": "Shadowless navigation bar"
      }}></img></p>
    <h4>{`Transparent`}</h4>
    <p><img parentName="p" {...{
        "src": "/img/ios-navigation-bar-transparent.png",
        "alt": "Transparent navigation bar"
      }}></img></p>
    <h3>{`Content Style`}</h3>
    <p>{`There are two standard content styles. The content style defines how foreground content such as text should be displayed.`}</p>
    <h4>{`Default`}</h4>
    <p>{`Dark content style to be used on a navigation bar with a light background.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-navigation-bar-default.png",
        "alt": "Default content style"
      }}></img></p>
    <h4>{`Light`}</h4>
    <p>{`Light content style to be used on a navigation bar with a dark background.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-navigation-bar-transparent.png",
        "alt": "Light content style"
      }}></img></p>
    <h2>{`Public API`}</h2>
    <h3>{`Appearance struct`}</h3>
    <h4><inlineCode parentName="h4">{`var isTranslucent: Bool`}</inlineCode></h4>
    <h4><inlineCode parentName="h4">{`var backgroundImage: UIImage?`}</inlineCode></h4>
    <h4><inlineCode parentName="h4">{`var barTintColor: UIColor?`}</inlineCode></h4>
    <h4><inlineCode parentName="h4">{`var shadowImage: UIImage?`}</inlineCode></h4>
    <h4><inlineCode parentName="h4">{`var tintColor: UIColor??`}</inlineCode></h4>
    <p>{`If set to `}<inlineCode parentName="p">{`nil`}</inlineCode>{`, will default to the content style’s foreground color. Set to `}<inlineCode parentName="p">{`.some(nil)`}</inlineCode>{` to disable this default and actually set the navigation bar’s tint color to nil.`}</p>
    <h4><inlineCode parentName="h4">{`var titleTextAttributes: [NSAttributedString.Key: Any]?`}</inlineCode></h4>
    <p>{`If no foreground color is specified, will default to the content style’s foreground color.`}</p>
    <h4><inlineCode parentName="h4">{`var largeTitleTextAttributes: [NSAttributedString.Key: Any]?`}</inlineCode></h4>
    <p>{`If no foreground color is specified, will default to the content style’s foreground color.`}</p>
    <h4><inlineCode parentName="h4">{`public init(isTranslucent: Bool, backgroundImage: UIImage?, barTintColor: UIColor?, tintColor: UIColor??, shadowImage: UIImage?, titleTextAttributes: [NSAttributedString.Key: Any]?, largeTitleTextAttributes: [NSAttributedString.Key: Any]?)`}</inlineCode></h4>
    <h4><inlineCode parentName="h4">{`public static let default: NavigationBar.Appearance`}</inlineCode></h4>
    <p>{`Default navigation bar appearance.`}</p>
    <h4><inlineCode parentName="h4">{`public static let shadowless: NavigationBar.Appearance`}</inlineCode></h4>
    <p>{`Navigation bar appearance without a bottom shadow.`}</p>
    <h4><inlineCode parentName="h4">{`public static let transparent: NavigationBar.Appearance`}</inlineCode></h4>
    <p>{`Transparent navigation bar appearance.`}</p>
    <h3>{`ContentStyle enum`}</h3>
    <h4><inlineCode parentName="h4">{`case default`}</inlineCode></h4>
    <p>{`Style for use on a light background.`}</p>
    <h4><inlineCode parentName="h4">{`case light`}</inlineCode></h4>
    <p>{`Style for use on a dark background.`}</p>
    <h4><inlineCode parentName="h4">{`var foregroundColor: UIColor`}</inlineCode></h4>
    <p>{`Color used for foreground content such as text and template icons.`}</p>
    <h3>{`NavigationBar`}</h3>
    <h4><inlineCode parentName="h4">{`public static func configure(_ navigationBar: UINavigationBar, appearance: Appearance = .default, content: ContentStyle = .default)`}</inlineCode></h4>
    <p>{`Configure a navigation bar with the specified appearance and content style.`}</p>
    <p>{`Pass `}<inlineCode parentName="p">{`UINavigationBar.appearance()`}</inlineCode>{` for the `}<inlineCode parentName="p">{`navigationBar`}</inlineCode>{` argument to set the default appearance of all navigation bars.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      